import { routerWithQueryClient } from '@tanstack/react-router-with-query'
import { createRouter as createTanstackRouter } from '@tanstack/react-router'
import * as TanstackQuery from '@/integrations/tanstack-query/root-provider'
import { routeTree } from '@/routeTree.gen'

export const createRouter = () => {
	const router = routerWithQueryClient(
		createTanstackRouter({
			routeTree,
			context: {
				...TanstackQuery.getContext(),
			},
			scrollRestoration: true,
			defaultPreloadStaleTime: 0,
		}),
		TanstackQuery.getContext().queryClient,
	)

	return router
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof createRouter>
	}
}
